import(/* webpackMode: "eager" */ "C:\\pickeat\\pickeat_mall\\src\\app\\[locale]\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "C:\\pickeat\\pickeat_mall\\src\\app\\components\\ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "C:\\pickeat\\pickeat_mall\\src\\app\\context\\AppContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoadingProvider"] */ "C:\\pickeat\\pickeat_mall\\src\\app\\context\\LoadingContext.tsx");
